// extracted by mini-css-extract-plugin
export default {"button":"ButtonsUtil_button__2WxrY","buttonWrapper":"ButtonsUtil_buttonWrapper__rLzn+","info":"ButtonsUtil_info__jSAEv"};